<template>
    <div class="customers-learning">
        
        <content-switch
        :items="switchItems"
        :selectedItem="selectedItem"
        :counts="counts"
        @selectItem="handleSelectItem($event)" />
        
        <claims-table v-show="selectedItem === 'claims'" @finishedLoading="updateCount('claims', $event)"/>
        
    </div>
</template>

<script>

export default {
    data () {
        return {
            selectedItem: 'claims',
            counts: {
                claims: null
            },
            switchItems: [
                {
                    name: 'Afsluttede reklamationer',
                    slug: 'claims'
                }
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
        }
    },
    mounted () {
        this.$store.state.view = 'operations'
    },
    components: {
        'claims-table': require('./operations/claims.vue')
    }
}
</script>



// WEBPACK FOOTER //
// operations.vue?2fc4409f